module.exports = __webpack_public_path__ + "media/images/logo-coris-bank-83a799e9c332feb7869a130da5021f53.jpg";